module.exports = __webpack_public_path__ + "static/media/p12.bcf886a0.png";